import Vue from 'vue';
import { isMatch, isWithinInterval, isAfter, parse as parseDate } from 'date-fns';

Vue.prototype.$rules = {
	required({ msg = 'Campo Obrigatório' } = {}) {
		return v => !!v || msg;
	},
	conterEspaco({ msg = 'Campo deve conter espaço' } = {}) {
		return v =>
			v && v.split && v.split(' ') && v.split(' ') && v.split(' ')[1]
				? true
				: msg;
	},
	validDate({ format = 'dd/MM/yyyy', msg = 'Data inválida' } = {}) {
		return v => (isMatch(v, format) ? true : msg);
	},
	between({ start, end, msg = 'Fora do intervalo' } = {}) {
		let template = (tpl, args) =>
		tpl.replace(/\${(\w+)}/g, (_, v) => args[v]);
		return v => v >= start && v <= end  ? true : template(msg, {start,end});
	},
	outOfIntervals({
		intervals = [],
		format = 'dd/MM/yyyy',
		msg = 'Data contida em outros intervalos',
		startKey = 'start',
		endKey = 'end'
	} = {}) {
		return v => {
			let ret = true;
			intervals.forEach(obj => {
				let template = (tpl, args) =>
					tpl.replace(/\${(\w+)}/g, (_, v) => args[v]);
				if (
					isMatch(v, format) &&
					isMatch(obj[startKey], format) &&
					isMatch(obj[endKey], format)
				) {
					let date = parseDate(v, format, new Date());
					let start = parseDate(obj[startKey], format, new Date());
					let end = parseDate(obj[endKey], format, new Date());
					if (isWithinInterval(date, { start, end })) {
						ret = template(msg, obj);
					}
				}
			});
			return ret;
		};
	},
	betweenDate({
		format = 'dd/MM/yyyy',
		msg = 'Fora do intervalo',
		startKey = 'start',
		endKey = 'end'
	} = {}) {
		if (
			isMatch(startKey, format) &&
			isMatch(endKey, format)
		) {
			let start = parseDate(startKey, format, new Date());
			let end = parseDate(endKey, format, new Date());
			
			return isAfter(end, start) ? true : msg;
		}
		else {
			return true;
		}
	}

};
